import { JSX } from "react";
import { QESButton } from "../qes-standards";

interface NewActionMenuItemProps {
  /**
   * The string or element to display inside the option.
   */
  display: string | JSX.Element;
  /**
   * Grays out the option and negates its click event, conveying that it can't be selected.
   * This is slightly different from isSelected, because it conveys to screen readers that this item 
   * cannot be selected, while it does not say it is currently selected.
   */
  disabled?: boolean;
  /**
   * Grays out the option and negates its click event, because it's already selected. 
   * This is slightly different from disabled, because it conveys to screen readers that this item 
   * has been selected from the list of presented options.
   */
  isSelected?: boolean;
  /**
   * The event to fire when the option is clicked.
   */
  onClick: () => void;
  /**
   * A unique id for the option, helpful for QA Automation.
   */
  testId: string;
}

/**
 * A simple, standard button for use inside NewActionMenu.
 */
export const NewActionMenuItem = (props: NewActionMenuItemProps): JSX.Element => {
  return (
    <QESButton
      qesType="none"
      className="new-action-menu-item"
      data-selected={props.isSelected}
      qesTestId={props.testId}
      onClick={() => props.isSelected || props.disabled ? null : props.onClick()}
      /* We don't want to use disabled,
        because that prevents the button from ever receiving tab focus
        and is "invisible" to screen readers.
        With aria-disabled, the element is visible but announces
        that it is disabled.
      */
      aria-disabled={props.isSelected || props.disabled}
    >
      {props.display}
    </QESButton>
  )
}